import { Link } from 'react-router-dom';
import LogoCizim from '../components/brand/LogoCizim';
import { logoUst } from '../components/brand/markaYollari';
import Footer from './home/components/Footer';
import Seo from '../components/Seo';

interface Faq {
  q: string;
  a: string;
}

interface FaqGroup {
  title: string;
  icon: string;
  items: Faq[];
}

// Tek kaynak: hem gorunur icerik hem FAQPage JSON-LD buradan uretilir.
// Google kurali: semadaki metin sayfada gorunen metinle ayni olmali.
const FAQ_GROUPS: FaqGroup[] = [
  {
    title: 'Genel',
    icon: 'ri-community-line',
    items: [
      {
        q: 'Mahallebi nedir?',
        a: 'Mahallebi, mahalle bazlı bir sosyal ticaret platformudur. Yakınındaki komşularınla ikinci el eşya alıp satabilir, hizmet sunabilir, ihtiyacını paylaşabilir, etkinlik ve duyuru yayınlayabilirsin. Acil durumlarda en yakın komşulardan yardım istemeyi sağlayan acil yardım modülü de bulunur.',
      },
      {
        q: 'Mahallebi ücretsiz mi?',
        a: 'Evet. Uygulamayı indirmek, ilan vermek ve komşularınla mesajlaşmak tamamen ücretsizdir. İlanlardan komisyon alınmaz.',
      },
      {
        q: 'Mahallebi hangi cihazlarda kullanılabilir?',
        a: "Android için Google Play'de, iPhone için App Store'da yayındadır; web tarayıcısından mahallebi.com üzerinden de kullanılabilir.",
      },
      {
        q: 'Mahallebi\'yi diğer ikinci el uygulamalarından ayıran nedir?',
        a: 'Odak noktası mahalledir: ilanlar yakınlığa göre sıralanır, alışveriş kargo yerine elden teslimle yapılır. Güven puanı ve rozet sistemi, acil yardım modülü, mahalle duyuruları ve esnaf vitrinleri gibi topluluk özellikleri, klasik ilan sitelerinden farklı olarak komşuluk ilişkisini merkeze alır.',
      },
    ],
  },
  {
    title: 'Üyelik ve Giriş',
    icon: 'ri-user-line',
    items: [
      {
        q: 'Nasıl üye olurum?',
        a: 'Google hesabı, Apple hesabı veya telefon numaranla birkaç adımda üye olabilirsin. Üyelik ücretsizdir.',
      },
      {
        q: 'Üye olmadan uygulamayı kullanabilir miyim?',
        a: 'Evet, misafir modunda ilanları ve mahalle akışını görüntüleyebilirsin. İlan vermek, mesajlaşmak ve acil yardım özelliklerini kullanmak için üyelik gerekir.',
      },
    ],
  },
  {
    title: 'İlanlar ve Alışveriş',
    icon: 'ri-shopping-bag-line',
    items: [
      {
        q: 'Hangi tür ilanlar verebilirim?',
        a: 'Dört ilan tipi vardır: Ürün (satış veya hediye), Hizmet (saatlik, günlük, proje bazlı veya ücretsiz), Talep (ihtiyaç bildirimi) ve Duyuru (etkinlik, haber, kayıp ilanı gibi).',
      },
      {
        q: 'İlanım kimlere görünür?',
        a: 'İlanlar konum bazlı çalışır ve yakındaki komşulara öncelikli gösterilir. Kullanıcılar mesafe filtresiyle arama yapabilir; duyurular daha geniş bir çevreye ulaşır.',
      },
      {
        q: 'Ödeme nasıl yapılır?',
        a: 'Mahallebi üzerinden ödeme alınmaz; uygulamada ödeme sistemi yoktur. Alışveriş komşular arasında yüz yüze, elden yapılır. Buluşmalarda gündüz saatlerini ve açık, bilinen noktaları tercih etmeni öneririz.',
      },
      {
        q: 'Konum bilgim güvende mi?',
        a: 'Evet. Tam adresin hiçbir zaman paylaşılmaz; ilan konumu haritada yaklaşık olarak gösterilir. Konumun yalnızca ilanların yakınlığa göre sıralanması için kullanılır.',
      },
    ],
  },
  {
    title: 'Güven ve Topluluk',
    icon: 'ri-shield-check-line',
    items: [
      {
        q: 'Güven puanı ve rozetler nedir?',
        a: 'Her kullanıcının 0-100 arası bir güven puanı vardır; tamamlanan alışverişler, aldığın 1-5 yıldız değerlendirmeler ve topluluk katkılarınla artar. "Güvenilir Komşu" veya "Yardım Kahramanı" gibi rozetler profil güvenilirliğini gösterir.',
      },
      {
        q: 'Sorunlu bir ilan veya kullanıcıyı nasıl bildiririm?',
        a: 'Her ilan ve profil sayfasında şikayet et seçeneği bulunur. Bildirimler moderasyon ekibi tarafından incelenir; ayrıca istediğin kullanıcıyı engelleyebilirsin.',
      },
      {
        q: 'Acil yardım modülü nasıl çalışır?',
        a: 'Bebek malzemesi, ilaç, yiyecek gibi acil bir ihtiyacın olduğunda talebini oluşturursun; en yakındaki komşulara anlık bildirim gider ve yardım edebilecek biriyle hızla eşleştirilirsin.',
      },
    ],
  },
  {
    title: 'İşletmeler ve Hesap',
    icon: 'ri-store-2-line',
    items: [
      {
        q: 'İşletme hesabı nedir, nasıl açılır?',
        a: 'Mahalle esnafı için vitrin özelliğidir: işletme profili; logo, çalışma saatleri, ilanlar ve müşteri yorumlarını bir arada gösterir. Profil sayfandaki "İşletmem" adımından ücretsiz oluşturabilirsin.',
      },
      {
        q: 'Hesabımı nasıl silerim?',
        a: 'Uygulamada Ayarlar bölümünden hesabını silebilirsin. Ayrıntılı adımlar ve web üzerinden silme talebi için mahallebi.com/account-deletion sayfasına bakabilirsin.',
      },
    ],
  },
];

const faqJsonLd = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQ_GROUPS.flatMap((g) => g.items).map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: { '@type': 'Answer', text: a },
  })),
});

export default function SSS() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Seo
        title="Sıkça Sorulan Sorular | Mahallebi"
        description="Mahallebi hakkında merak edilenler: üyelik, ilan verme, ödeme, konum gizliliği, güven puanı, acil yardım ve işletme hesabı soruları."
        path="/sss"
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: faqJsonLd }} />

      {/* Header */}
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex-shrink-0">
              <LogoCizim src="/images/logo.webp" alt="Mahallebi" yol={logoUst} renk="#8C1427" className="h-10" />
            </Link>
            <Link to="/" className="text-sm text-gray-500 hover:text-[#e77e23] transition-colors">
              ← Ana Sayfa
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl font-bold text-[#111827] mb-3">Sıkça Sorulan Sorular</h1>
          <p className="text-gray-600 mb-10">
            Mahallebi hakkında merak ettiklerin. Aradığın cevabı bulamazsan{' '}
            <a href="mailto:info@ubsbilisim.com" className="text-[#e77e23] hover:text-[#d35400] font-medium">
              info@ubsbilisim.com
            </a>{' '}
            adresinden bize yazabilirsin.
          </p>

          {FAQ_GROUPS.map((group) => (
            <section key={group.title} className="mb-10">
              <h2 className="flex items-center gap-2 text-xl font-bold text-[#111827] mb-4">
                <i className={`${group.icon} text-[#e77e23]`}></i>
                {group.title}
              </h2>
              <div className="space-y-3">
                {group.items.map((item) => (
                  <details
                    key={item.q}
                    className="group bg-[#f8f7f6] rounded-xl border border-gray-100 open:bg-white open:shadow-sm"
                  >
                    <summary className="flex items-center justify-between gap-4 px-5 py-4 cursor-pointer list-none font-semibold text-[#111827]">
                      {item.q}
                      <i className="ri-arrow-down-s-line text-xl text-[#e77e23] transition-transform group-open:rotate-180"></i>
                    </summary>
                    <p className="px-5 pb-5 text-[#374151] leading-relaxed">{item.a}</p>
                  </details>
                ))}
              </div>
            </section>
          ))}

          <div className="mt-12 rounded-2xl bg-[#e77e23]/10 p-6 text-center">
            <p className="font-semibold text-[#111827] mb-3">Mahallebi'yi denemeye hazır mısın?</p>
            <div className="flex flex-wrap justify-center gap-3">
              <a
                href="https://play.google.com/store/apps/details?id=com.mahallebi.tr&hl=tr"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 bg-[#e77e23] text-white font-semibold rounded-full hover:bg-[#d56d12] transition-colors"
              >
                <i className="ri-google-play-fill text-xl mr-2"></i>
                Google Play'den İndir
              </a>
              <a
                href="https://apps.apple.com/tr/app/mahallebi-mahalle-pazar%C4%B1/id6793705970"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 bg-[#111827] text-white font-semibold rounded-full hover:bg-black transition-colors"
              >
                <i className="ri-apple-fill text-xl mr-2"></i>
                App Store'dan İndir
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
